import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSpacer: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="spacer,seperator"><path d="M2.75 4.75H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 12H5.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10.75 12H13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.75 12H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 19.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSpacer;
